import React from 'react';
import {Typography} from '@material-ui/core';

/**
 * Display user data
 * @param userId
 * @param userName
 */
const UserData = ({userId, userName}: {userId: string, userName: string}) => {

  return (
      <Typography variant="body1" align="right">
        Лицевой счет: {userId}<br/>
        ФИО: {userName}
      </Typography>
  );
};

export default UserData;
